import { t, Trans } from '@lingui/macro';
import { Address, BookingAddress } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { getLongAddressName, NoddiBasicCard } from 'noddi-ui-web';
import { getBookingTimeWindowDisplayText } from 'noddi-util';

type InfoSteps = 'address' | 'timeWindow' | 'communication';

interface CommonBookingInfoProps {
  address?: Address | BookingAddress;
  timeWindow?: {
    startsAt: string;
    endsAt: string;
    timeZone: string;
  };
  excludeSteps?: InfoSteps[];
}

export const CommonBookingInfoCard = ({ address, timeWindow, excludeSteps }: CommonBookingInfoProps) => {
  const timeWindowDisplay = timeWindow
    ? getBookingTimeWindowDisplayText(timeWindow)
    : t`Problems with the last time slot`;

  return (
    <NoddiBasicCard className='flex flex-col gap-3'>
      {address && !excludeSteps?.includes('address') && (
        <div className='flex gap-2'>
          <NoddiIcon name='LocationPin' />
          <p>{getLongAddressName(address)}</p>
        </div>
      )}
      {timeWindow && !excludeSteps?.includes('timeWindow') && (
        <div className='flex gap-2'>
          <NoddiIcon name='Calendar' />
          <p>{timeWindowDisplay}</p>
        </div>
      )}
      {!excludeSteps?.includes('communication') && (
        <div className='flex gap-2'>
          <NoddiIcon name='Phone' />
          <p>
            <Trans>We'll text you the day before with estimated arrival time and when you're next on the list</Trans>
          </p>
        </div>
      )}
    </NoddiBasicCard>
  );
};
